import { useTradeStats } from "#/services/kyan/hooks/useTradeStats";
import { useAccount } from "#/store/wallet/account/account";

import { getNextReferralProgress } from "../../ReferralLinks.helpers";

export const useNextReferralController = () => {
  const { isAccountConnected } = useAccount();
  const { data: tradeStats } = useTradeStats();
  const totalAccountVolume =
    tradeStats?.groups?.[0]?.total_volume_notional ?? 0;

  return { ...getNextReferralProgress(totalAccountVolume), isAccountConnected };
};
